var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { API_PATHS } from "../types/apiPaths";
var getHeaders = function () { return ({
    "Cache-Control": "no-cache, no-store, must-revalidate",
    Pragma: "no-cache",
    Expires: "0",
}); };
export var fetchEnvironmentVariables = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.get('admin/environment-variables-users', { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Error: ".concat(response.statusText));
                }
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var syncToLegalDeposits = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post('admin/sync-to-legal-deposits', { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Error: ".concat(response.statusText));
                }
                return [2 /*return*/, response.json()];
        }
    });
}); };
var readStatus = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    var body;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!!response.ok) return [3 /*break*/, 2];
                return [4 /*yield*/, response.text()];
            case 1:
                body = _a.sent();
                throw new Error(body || "Error: ".concat(response.status, " ").concat(response.statusText));
            case 2: return [2 /*return*/, response.json()];
        }
    });
}); };
export var startKeycloakBackfill = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = readStatus;
                return [4 /*yield*/, kyInstance.post(API_PATHS.USERS_KEYCLOAK_BACKFILL, {
                        headers: getHeaders(),
                        throwHttpErrors: false,
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
export var fetchKeycloakBackfillStatus = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = readStatus;
                return [4 /*yield*/, kyInstance.get(API_PATHS.USERS_KEYCLOAK_BACKFILL, {
                        headers: getHeaders(),
                        throwHttpErrors: false,
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
export var sendTestEmail = function (kyInstance, to) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post('admin/send-test-email', {
                    headers: getHeaders(),
                    json: { to: to },
                })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Error: ".concat(response.statusText));
                }
                return [2 /*return*/];
        }
    });
}); };
/** Thrown when a mass-sending run is already in progress (HTTP 409). */
var RegistrationEmailRunningError = /** @class */ (function (_super) {
    __extends(RegistrationEmailRunningError, _super);
    function RegistrationEmailRunningError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RegistrationEmailRunningError;
}(Error));
export { RegistrationEmailRunningError };
var readRegistrationEmailStatus = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    var body;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (response.status === 409) {
                    throw new RegistrationEmailRunningError("Registration email is already being sent");
                }
                if (!!response.ok) return [3 /*break*/, 2];
                return [4 /*yield*/, response.text()];
            case 1:
                body = _a.sent();
                throw new Error(body || "Error: ".concat(response.status, " ").concat(response.statusText));
            case 2: return [2 /*return*/, response.json()];
        }
    });
}); };
export var fetchRegistrationEmailStatus = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = readRegistrationEmailStatus;
                return [4 /*yield*/, kyInstance.get(API_PATHS.ADMIN_REGISTRATION_EMAIL, {
                        headers: getHeaders(),
                        throwHttpErrors: false,
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
export var startRegistrationEmail = function (kyInstance, start) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = readRegistrationEmailStatus;
                return [4 /*yield*/, kyInstance.post(API_PATHS.ADMIN_REGISTRATION_EMAIL, {
                        headers: getHeaders(),
                        json: start,
                        throwHttpErrors: false,
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
export var stopRegistrationEmail = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = readRegistrationEmailStatus;
                return [4 /*yield*/, kyInstance.post(API_PATHS.ADMIN_REGISTRATION_EMAIL_STOP, {
                        headers: getHeaders(),
                        throwHttpErrors: false,
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
